<template>
    <transition name="fade">
        <div v-if="isExpanded" class="gc-bglayer-list">
            <LayerListItem
                    v-for="layer in sortedLayers"
                    :layer="layer"
                    v-on:selectLayer="onSelectLayer"
            ></LayerListItem>
        </div>
    </transition>
</template>

<script>
    import LayerListItem from "./LayerListItem"

    export default {
        name: "LayerList",
        components: {
            LayerListItem
        },
        props: {
            layers: {
                type: Array,
                required: true
            },
            isExpanded: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            sortedLayers: function () {
                let layerComparator = function (a, b) {
                    if (a.drawOrder > b.drawOrder) return 1;
                    if (a.drawOrder < b.drawOrder) return -1;
                    return 0;
                }
                return this.layers.sort(layerComparator);
            }
        },
        methods: {
            onSelectLayer: function (selectedLayer) {
                this.$emit('layerSelected', selectedLayer);
            }
        }
    }
</script>
